import React, { useState } from "react";
import ReactFlagsSelect from "react-flags-select";

export default function CountrySelect({ value, onChange }) {
  const [selected, setSelected] = useState(value || "");

  return (
    <div className="mb-4">
      <label className="block mb-1 font-medium text-[#2f2a1e]">
        Country
      </label>

      <ReactFlagsSelect
        selected={selected}
        onSelect={(code) => {
          setSelected(code);
          onChange(code);
        }}
        searchable={true}
        placeholder="Select your country"
        className="border border-[#e8e2d1] rounded"
      />
    </div>
  );
}
